import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ux6qfn4eb: FaireProductEntity = {
  token: "p_5ux6qfn4eb",
  type: "product",
  name: "I'm Not Sure What I'm Doing Out Of Bed Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c812943c3176223b627db125027a0cbe1d238a2639471d6499391632e93fa379.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3d030c0db982427ae1fda84e09870f1b0c0a0830a3b5c058060aa9408464ca6.jpeg",
    "https://cdn.faire.com/fastly/e589c784de7fd892887553dab9aae84a8c38d506e9e522f9197aa08761c2b19a.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/126d14b8be3b1da1e73252210f200c48df47ed97489b5a37d8ebf47753a2e2c5.jpeg",
    "https://cdn.faire.com/fastly/140770f0d7ca2ff49382a669ec880d73b214d961872fc267f05bdd42a8c30dea.jpeg"
  ],
  priceDollars: 3.38,
  description: "For when you're technically dressed, but spiritually horizontal. Ideal for work meetings, errands, and other horrible mistakes.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:19.810Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
